<template>
  <div>
    <v-container style="padding: 0">
      <v-card height="50vh">
        <v-col>
          <div class="text-h4 px-2 pt-10 text--center text--secondary block">
            Documents
          </div>
        </v-col>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
